// 统一显示比赛信息

//检查比赛是否为月赛
function isMonthlyCompetition(gameId) {
    return 200600 < gameId && gameId < 220800;
}

//检查比赛是否为等级赛
function isLevelAssessment(gameId) {
    let year = 2000 + Math.floor(gameId / 10000);
    let month = Math.floor(gameId % 10000 / 100);
    let mode = Math.floor(gameId % 100 / 10);
    let level = gameId % 10;

    return (2020 <= year && year <= 2029 &&
        1 <= month && month <= 12
        && (mode == 0 || mode == 1)
        && (level <= 5));
}

//根据比赛ID获取对应的Key
export function gameKeyFilter(gameId) {
    if (isMonthlyCompetition(gameId)) {  // 原月赛模式
        /**
         * 月赛编号的规则是：年份(2)+月份(2)+模式(1)+可进入的等级(1)
         * 比如 220403 就是：2022年4月三级赛（图形化）
         */
        let year = 2000 + Math.floor(gameId / 10000);
        let month = Math.floor(gameId % 10000 / 100);
        let mode = Math.floor(gameId % 100 / 10);
        let level = gameId % 10;

        let keyMap = { // mode, level // 方便查找，不拼凑key
            0: {
                1: "blockly_level_competition_1",
                2: "blockly_level_competition_2",
                3: "blockly_level_competition_3",
                4: "blockly_level_competition_4",
                5: "blockly_level_competition_5",
                6: "blockly_level_competition_6",
            },
            1: {
                1: "python_level_competition_1",
                2: "python_level_competition_2",
                3: "python_level_competition_3",
                4: "python_level_competition_4",
                5: "python_level_competition_5",
                6: "python_level_competition_6",
            }
        }


        if (2020 <= year && year <= 2029 &&
            1 <= month && month <= 12) {
            return { key: keyMap[mode][level], keyValue: { year: year, month: month } };
            // return this.$t(keyMap[mode][level], { year: year, month: month });
        }
    }

    if (isLevelAssessment(gameId)) { // 2022年8月起改名为等级赛
        /**
         * 月赛编号的规则是：年份(2)+月份(2)+模式(1)+可进入的等级(1)
         * 比如 220403 就是：2022年4月三级赛（图形化）
         */
        let year = 2000 + Math.floor(gameId / 10000);
        let month = Math.floor(gameId % 10000 / 100);
        let mode = Math.floor(gameId % 100 / 10);
        let level = gameId % 10;

        let keyMap = { // mode, level // 方便查找，不拼凑key
            0: "blockly_level_competition",
            1: "python_level_competition",
        }

        if (2020 <= year && year <= 2029 &&
            1 <= month && month <= 12) {
            return { key: keyMap[mode], keyValue: { year: year, month: month, level: level } };
            // return this.$t(keyMap[mode][level], { year: year, month: month });
        }
    }

    return { key: "game_title_" + gameId };
}


// WEBPACK FOOTER //
// ./src/utils/gameInfo.js